type Props = {
  className?: string;
  imageSrc: string;
  children: React.ReactNode;
  imageClassName?: string;
};

const BackgroundImage = ({
  className = "",
  imageSrc,
  children = <></>,
  imageClassName = "",
}: Props) => {
  return (
    // bg-black prevents a transparent-to-black flash in FiveM/CEF when a parent
    // motion.div creates a new compositing layer (e.g. on filter/transform hover).
    // The background image covers this colour completely once loaded.
    <div className={`relative z-[1]  ${className}`}>
      <img
        draggable={false}
        src={imageSrc}
        alt="BG"
        className={`absolute top-0 left-0 w-full h-full object-cover z-[-1] ${imageClassName}`}
        loading="eager"
      />
      {children}
    </div>
  );
};

export default BackgroundImage;
